import { render, staticRenderFns } from "./DialogEmail.vue?vue&type=template&id=995eeffe&scoped=true&"
import script from "./DialogEmail.vue?vue&type=script&lang=js&"
export * from "./DialogEmail.vue?vue&type=script&lang=js&"
import style0 from "./DialogEmail.vue?vue&type=style&index=0&id=995eeffe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "995eeffe",
  null
  
)

export default component.exports